<template>
     <div class="record-purchaserequisition">
        <PageTitle icon="fa fa-exchange" main="Registro" sub="Requisição de Compra"/>
         <b-form>
               <b-row>
                    <input id="purchaserequisition-id" type="hidden" v-model="purchaserequisition.id" />
                    <b-col md="2" sm="12">
                        <b-form-group 
                            label="Data de Requisição:" 
                            label-for="purchaserequisition-requisition_date">
                        <b-form-input 
                            id="purchaserequisition-requisition_date" 
                            type="date"
                            v-model="purchaserequisition.requisition_date" 
                            :readonly="docRead"
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 

                    <b-col md="2" sm="12">
                            <b-form-group 
                                label="Status:" 
                                label-for="purchaserequisition-requisition_status_id">
                            <b-form-select 
                                id="purchaserequisition-requisition_status_id"
                                size="sm"
                                :readonly="docRead"
                                disabled
                                :options="documentstatus" 
                                v-model="purchaserequisition.requisition_status_id" />
                            </b-form-group>
                    </b-col>
               </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                    <b-form-group 
                            label="Solicitante:" 
                            label-for="purchaserequisition-requisition_employee_id">
                        <b-form-select id="purchaserequisition-requisition_employee_id"
                            size="sm"
                            :options="employees" 
                             :disabled="docRead"
                            v-model="purchaserequisition.requisition_employee_id" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Prazo (Dias):" 
                            label-for="purchaserequisition-priority_days">
                        <b-form-input 
                            id="purchaserequisition-priority_days" 
                             type="number"
                            v-model="purchaserequisition.priority_days"
                            size="sm"
                             :readonly="docRead"
                            placeholder="Prazo (Dias)..." />
                        </b-form-group>
                    </b-col> 
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Nº Controle Externo:" 
                            label-for="purchaserequisition-number_control">
                        <b-form-input 
                            id="purchaserequisition-number_control" 
                            type="text"
                            v-model="purchaserequisition.number_control"
                            size="sm"
                             :readonly="docRead"
                            placeholder="Nº Controle Externo..." />
                        </b-form-group>
                    </b-col> 
                </b-row>
               <b-row>
                    <b-col md="1" sm="2">
                        <b-form-group label="ID" label-for="entity-id">
                        <b-form-input id="entity-id" type="text"
                            v-model="purchaserequisition.entity_id"
                            @input="[setEntity(),getAdvancedValue()]"
                            :readonly="docRead"
                            v-on:keyup.enter="openModalEntity"
                            size="sm"
                            placeholder="Código..." /> 
                        </b-form-group>
                    </b-col>    
                         <b-link v-b-modal.modalEntity class="fa fa-search mt-4" ></b-link > 
                    <b-col md="6" sm="8">
                        <b-form-group 
                            label="Fornecedor:" 
                            label-for="entity-name_entity">
                        <b-form-input 
                            id="entity-name_entity" 
                            type="text"
                            v-model="entity.name_entity"
                            size="sm"
                            :readonly= 'true'
                            placeholder="Fornecedor..." />
                        </b-form-group>
                    </b-col> 
                    <b-col md="2" sm="2">
                        <b-form-group 
                            label="CPF/CNPJ:" 
                            label-for="entity-cnpj_cpf">
                        <b-form-input 
                            id="entity-cnpj_cpf" 
                            type="text"
                            v-model="entity.cnpj_cpf"
                            size="sm"
                            :readonly= 'true'
                            placeholder="" />
                        </b-form-group>
                    </b-col>   
                    <b-link 
                        v-b-modal.modalRegisterEntity 
                        class="fa fa-plus mt-4" >
                    </b-link >  
                    </b-row>


                    <b-row>
                        <b-col md="7" sm="12">
                            <b-form-group 
                                label="Observação:" 
                                label-for="purchaserequisition-comments">
                            <b-form-textarea 
                                id="purchaserequisition-comments"
                                :rows="2"
                                :max-rows="3"
                                size="sm"
                                :readonly="docRead"
                                v-model="purchaserequisition.comments"
                                placeholder="" />
                            </b-form-group>
                        </b-col>

                    </b-row>
         </b-form>
            <b-row>
            <b-col xs="12">
                <b-button   
                    size="lq" 
                    variant="dark"  
                    v-show="!docRead"
                    class="fa fa-save"
                    @click="savepurchaserequisition">
                    
                    </b-button>
                <b-button  
                    size="lq" 
                    variant="dark" 
                    title="Retornar tela de consulta"
                    class="ml-2 fa fa-reply"
                    @click="goback">
                </b-button>  
                <b-button   
                    size="lq" 
                    variant="dark" 
                    class="ml-2" 
                    v-if="this.purchaserequisition.requisition_status_id === 1"
                    @click="[confirmpurchaserequisition()]">
                    Confirmar
                </b-button>      
                <b-button
                     size="lq" 
                     variant="dark" 
                     class="ml-2" 
                     v-if="this.purchaserequisition.requisition_status_id === 2"
                    @click="[confirmpurchaserequisition()]">
                    Deconfirmar
                </b-button>      
            </b-col>
        </b-row>
        <hr>
         <b-card 
            bg-variant="light" 
            text-variant="dark"
            no-body 
            v-show="this.purchaserequisition.id > 0 ? true : false">
            <b-tabs  
                card 
                small>
                <b-tab title="Item" active>
                <b-row>                     
                    <b-col md="2" sm="12">
                        <b-button 
                             title = "Adicionar" 
                            size="lq" 
                            @click="setNewItem"
                            v-b-modal.modalpurchaserequisitionItem 
                            v-show="this.purchaserequisition.requisition_status_id === 1 && this.purchaserequisition.id > 0 ? true : false" 
                            variant="dark" 
                            class="mr-2 mb-2" 
                        > <i class="fa fa-plus">
                        </i></b-button>  
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                
                        <transition  
                                    name="slide" 
                                    type="animation" 
                                    appear> 
                            <b-table 
                                    class="table-responsive" 
                                    hover key="slide" 
                                    striped 
                                    :items="purchaserequisitionsitems" 
                                    :fields="fieldspurchaserequisitionItem"> 
                                <template v-slot:cell(actions)="data">
                                    <b-button 
                                         
                                        title = "Editar registro" 
                                        v-show="!docRead" 
                                        v-b-modal.modalpurchaserequisitionItem  
                                        size="sm" 
                                        variant="light" 
                                        @click="loadpurchaserequisitionsItem(data.item)" 
                                        class="mr-2 mt-2">
                                        <i class="fa fa-pencil"></i>
                                    </b-button>
                                    <b-button 
                                         title = "Excluir registro" 
                                        size="sm" 
                                        v-show="!docRead"  
                                        variant="light" 
                                        @click="modeItem = 'remove'" 
                                        class="mr-2 mt-2"
                                        v-if="modeItem === 'insert'"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                    <b-button 
                                         
                                        size="sm" 
                                        variant="success" 
                                        @click="[removeItem(data.item),modeItem = 'insert']" 
                                        class="mr-2 mt-2"
                                        v-if="modeItem === 'remove'"
                                    >
                                        <i class="fa fa-check"></i>
                                    </b-button>
                                    <b-button 
                                         
                                        size="sm" 
                                        variant="danger" 
                                        @click="modeItem = 'insert'" 
                                        class="mr-2 mt-2"
                                        v-if="modeItem === 'remove'"
                                    >
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                    <span class="mr-2 mt-2"  v-if="modeItem === 'remove'" > Deseja Excluir o registro? </span>
                                </template>
                            </b-table>
                        </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                    
                </b-tabs>
          </b-card>
            <b-modal id="modalEntity"
                    ref="modal"
                    title-tag = "h6"
                    size="lg"
                    title="Consulta de Cliente/Fornecedor"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    @ok="setSearchEntity"
                    >
                    <EntitySearchModal 
                    @setEntityId="entity_id=$event"
                    @setEntityName="entity.name_entity=$event"
                    @setEntityCnpjCpf="entity.cnpj_cpf=$event"
                    />
            </b-modal>
         <b-modal id="modalItem"
                    ref="modal"
                     hide-footer
                    title-tag = "h6"
                    @shown="focusModalItem"
                    size="lg"
                    title="Consulta de Item"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    >
                    <b-form>
                        <b-row>
                            <b-col md="8" sm="8">
                                <b-form-group 
                                    label="Descrição:" 
                                    label-for="item-complements_name">
                                <b-form-input 
                                    id="item-complements_name" 
                                    type="text"
                                    v-model="item.complements_name"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="Nome..." />
                                </b-form-group>
                            </b-col> 
                            <b-col md="2" sm="2">
                                <b-form-group label="Und:" label-for="entity-initials">
                                <b-form-input 
                                    id="entity-initials" 
                                    type="text"
                                    v-model="item.initials"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="" />
                                </b-form-group>
                            </b-col>  
                        </b-row>
                        <b-row>
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <label 
                                        class="control-label"> 
                                        <i class="fa fa-search"></i>  
                                        Pesquisar 
                                    </label> 
                                    <b-button 
                                         
                                        size="sm" 
                                        class=" ml-2 mb-2 fa fa-search" 
                                        @click="[loadItems(),showItem = !showItem]" 
                                        variant="secondary" ></b-button>
                                    <input 
                                        type="text" 
                                        icon="search" 
                                        v-model="searchItem" 
                                        ref="focusItem"
                                        v-on:keyup.enter="[loadItems(),showItem =true]"
                                        placeholder="Informe a descrição" 
                                        class="form-control">
                                    <b-form-select 
                                        id="item-group_item_id"
                                        class="mt-2"
                                        size="sm"
                                        :options="groupitems" 
                                        @input="loadItems"
                                        v-model="group_item_id" />    
                                </div>
                            </div>
                        </b-row>   
                        <b-table 
                            class="table-responsive" 
                            hover 
                            striped 
                            v-show="showItem" 
                            :per-page="perPage" 
                            :current-page="currentPage" 
                            :items="filteredListItems" 
                            :fields="fieldsItems">
                            <template 
                                v-slot:cell(actions)="data">
                                    <b-button 
                                         
                                        title = "Selecionar o registro" 
                                        size="sm" 
                                        variant="secondary" 
                                        @click="[setItemSearch(data.item),showItem= !showItem,hideModal()]" class="mr-2 mt-2">
                                        <i class="fa fa-check-square-o"></i>
                                    </b-button>
                                </template>   
                        </b-table>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rowsItems"
                            :per-page="perPage"
                            aria-controls="my-table"
                        ></b-pagination> 
                    </b-form>
        </b-modal>

        <b-modal id="modalpurchaserequisitionItem"
                ref="modal"
                size="xl"
                title-tag = "h6"
                @shown="focusModalEntryItem"
                title="Item da requisição"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
                @ok="savePurchaseRequisitionItem"
            >
           <b-form>

                <b-row>
                    <input 
                        id="purchaserequisitionsitem-item_stock_id" 
                        type="hidden" 
                        v-model="purchaserequisitionsitem.item_stock_id" />
                    <b-col md="2" sm="2">
                        <b-form-group 
                            label="ID:" 
                            label-for="purchaserequisitionsitem-item_id">
                        <b-form-input 
                            id="purchaserequisitionsitem-item_id" 
                            type="text"
                            ref="focusEntryItem"
                            v-model="purchaserequisitionsitem.item_id"
                            @input="[setItem(),loadItemsStock()]"
                            v-on:keyup.enter="purchaserequisitionsitem&&purchaserequisitionsitem.item_id > 0 ? focusModalEntryItemQuantity() : openModalItem()"
                            size="sm"
                            placeholder="Código..." />
                        </b-form-group>
                        </b-col> 
                            <b-link 
                                class="fa fa-search mt-4" 
                                v-b-modal.modalItem 
                                @click="[loadItems(),showItem=true]" 
                            >
                            </b-link >    
                        <b-col md="8" sm="8">
                                <b-form-group 
                                    label="Nome:" 
                                    label-for="item-complements_name">
                                <b-form-input 
                                    id="item-complements_name" 
                                    type="text"
                                    v-model="item.complements_name"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="Nome..." />
                                </b-form-group>
                        </b-col>        
                        <b-col md="1" sm="2">
                            <b-form-group 
                                label="Unid:" 
                                abel-for="item-initials">
                            <b-form-input 
                                id="item-initials" 
                                type="text"
                                v-model="item.initials"
                                size="sm"
                                :readonly= 'true'
                                placeholder="Unid." />
                            </b-form-group>
                        </b-col> 
                    </b-row>
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Qtde:" 
                                label-for="purchaserequisitionsitem-quantity">
                            <b-form-input 
                                id="purchaserequisitionsitem-quantity" 
                                v-model="purchaserequisitionsitem.quantity" 
                                ref="focusEntryItemQuantity"
                                @input="ItemValue"
                                v-on:keyup.enter="focusModalEntryItemValueUnit"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Valor Unitário (Estimado):" 
                                label-for="purchaserequisitionsitem-value_unit_estimate">
                            <b-form-input 
                                id="purchaserequisitionsitem-value_unit_estimate" 
                                v-model="purchaserequisitionsitem.value_unit_estimate" 
                                ref="focusEntryItemValueUnit"
                                 @input="[ItemValue(),ItemUnitFinalValue()]"
                                v-on:keyup.enter="focusModalEntryItemValueDesc"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Valor Total (Estimado):" 
                                label-for="purchaserequisitionsitem-value_total_estimate">
                            <b-form-input 
                                id="purchaserequisitionsitem-value_total_estimate" 
                                v-model="purchaserequisitionsitem.value_total_estimate" 
                                type="number"
                                size="sm"
                                :readonly= 'true'
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                      <b-card no-body>
                         <b-tabs card >
                             <b-tab title="Apontamento do Custo" active> 
                        <b-row>
                            <b-col md="6" sm="12">
                                <b-form-group 
                                label="Centro de Resultado:" 
                                label-for="purchaserequisitionsitem-cost_center_id">
                                <b-form-select id="purchaserequisitionsitem-cost_center_id"
                                size="sm"
                                :options="costcenters" 
                                v-model="purchaserequisitionsitem.cost_center_id" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                            <b-row>
                            <b-col md="2" sm="2">
                                <b-form-group 
                                    label="ID" 
                                    label-for="purchaserequisitionsitem.equipment-id">
                                <b-form-input 
                                    id="purchaserequisitionsitem.equipment-id" 
                                    type="text"
                                    v-model="purchaserequisitionsitem.equipment_id"
                                    @input="setEquipment()"
                                    size="sm"
                                    placeholder="Código..." /> 
                                </b-form-group>
                            </b-col>    
                                <b-link 
                                    v-b-modal.modalEquipment 
                                    class="fa fa-search mt-4" >
                                </b-link > 
                                <b-col md="6" sm="8">
                                <b-form-group 
                                    label="Equipamento:" 
                                    label-for="equipment-name_equipment">
                                <b-form-input 
                                    id="equipment-name_equipment" 
                                    type="text"
                                    v-model="equipment.name_equipment"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="Nome..." />
                                </b-form-group>
                            </b-col> 
                            <b-col md="3" sm="2">
                                <b-form-group 
                                    label="Código do Equipamento:" 
                                    label-for="equipment-internal_code_equipment">
                                <b-form-input 
                                    id="equipment-internal_code_equipment" 
                                    type="text"
                                    v-model="equipment.internal_code_equipment"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="" />
                                </b-form-group>
                            </b-col>  
                            </b-row>
                             </b-tab>

                         </b-tabs>
                      </b-card>   
           </b-form>

        </b-modal>
        <b-modal id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag = "h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <EntityModal/>
        </b-modal>
        <b-modal id="modalEquipment"
                    ref="modal"
                    title-tag = "h6"
                    size="lg"
                    title="Consulta de Equipamento"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    @ok="setSearchEquipment"
                    >
                    <EquipamentSearchModal 
                        @setEquipmentId="equipment_id=$event"
                        @setEquipmentName="equipment.name_equipment=$event"
                        @setEntityInternalCode="equipment.internal_code_equipment=$event"
                />
            </b-modal>

    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
import EquipamentSearchModal from '../util/EquipamentSearchModal'
var moment = require('moment-timezone')

export default {
      name: 'Recordpurchaserequisition',
      components: {PageTitle,EntityModal,EntitySearchModal,EquipamentSearchModal },
      data: function() {
          return {
                mode: 'save',
                modeItem: 'insert',
                entity_id: null,
                equipment_id: null,
                docRead: false,
                showItemStock: false,
                showEntity: false,
                showItem: false,
                group_item_id:null,
                searchItem: '',
                documentstatus:[],
                purchaserequisition: {},
                purchaserequisitionsitem: {},
                purchaserequisitionsitems:[],
                entity: {},
                equipment: {},
                costcenters: [],
                groupitems:[],
                typecosts: [],
                item:{},
                items: [],
                employees:[],
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                perPage: 5,
                currentPage: 1,
                fieldsEntity: [
                    { key: 'id', label: 'Código', sortable: true },
                    { key: 'name_entity', label: 'Nome', sortable: true },
                    { key: 'fantasy_name', label: 'Nome Fantasia', sortable: true },
                    { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                    { key: 'blocked', label: 'Bloqueado', sortable: false,
                            formatter: value => value ? 'Sim' : 'Não' },               
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsItemStock: [
                    { key: 'item_id', label: 'Item', sortable: false },   
                    { key: 'complements_name', label: 'Descrição', sortable: false },   
                    { key: 'location', label:"Complemento", sortable:false },
                    { key: 'initials', label: 'Und.', sortable: false },      
                    { key: 'stock_quantity', label: 'Qtde. Estoque', sortable: false },       
                    { key: 'price_unit_stock', label: 'Vr. Custo', sortable: false },   
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsItems:[
                    { key: 'id', label: 'Item', sortable: false },   
                    { key: 'complements_name', label: 'Descrição', sortable: false, variant: 'secondary' }, 
                    { key: 'initials', label: 'Und.', sortable: false },   
                    { key: 'name_group_item', label: 'Grupo de Item', sortable: false },  
                    { key: 'actions', label: 'Ações', variant: 'light' }       
                ],
                fieldspurchaserequisitionItem:[
                    { key: 'item_id', label: 'Item', sortable: false }, 
                    { key: "complements_name", label: "Descrição do Item", sortable:false }, 
                    { key: 'initials', label: 'Und.', sortable: false },       
                    { key: 'quantity', label: 'Qtde.', sortable: false },     
                     { key: 'quantity_purchase', label: 'Comprado', sortable: false },
                    { key: 'quantity_sald', label: 'Saldo', sortable: false },  
                    { key: 'value_unit_estimate', label: 'Vr. Unitário', sortable: false },
                    { key: 'value_total_estimate', label: 'Vr. Total', sortable: false },
                    { key: 'actions', label: 'Ações' }
                ]
          }
         
      },
    computed: {
        user(){
            return this.$store.state.user
        },
        compan(){
            return this.$store.state.compan
        },
        filteredList() {
            return this.entitys.filter(entity => {
                return ( 
                        entity.name_entity.toLowerCase().includes(this.searchEntity.toLowerCase()) || 
                        entity.cnpj_cpf.toLowerCase().includes(this.searchEntity.toLowerCase())
                )
            })
        },
        filteredListItems() {
            return this.items.filter(item => {
                return item.complements_name.toLowerCase().includes(this.searchItem.toLowerCase())
                })
        },
        rows() {
            return this.entitys.length
        },
        rowsItems() {
            return this.items.length
        }
    },
    methods:{
            finalValue(){
                return this.purchaserequisitionsplot.final_value = parseFloat((this.purchaserequisitionsplot.portion_value - (this.purchaserequisitionsplot.discount_value ? this.purchaserequisitionsplot.discount_value : 0)) + + (this.purchaserequisitionsplot.fine_value ? this.purchaserequisitionsplot.fine_value : 0) + + (this.purchaserequisitionsplot.interest_rate_value ? this.purchaserequisitionsplot.interest_rate_value : 0)).toFixed(2)
            },
            ItemValue(){
                return this.purchaserequisitionsitem.value_total_estimate = parseFloat(parseFloat(this.purchaserequisitionsitem.quantity ? this.purchaserequisitionsitem.quantity : 0) * (parseFloat(this.purchaserequisitionsitem.value_unit_estimate ? this.purchaserequisitionsitem.value_unit_estimate : 0) - (this.purchaserequisitionsitem.entry_value_discount ? this.purchaserequisitionsitem.entry_value_discount : 0))).toFixed(2)
            },
            ItemUnitFinalValue(){
                return this.purchaserequisitionsitem.entry_final_value_unit = parseFloat((parseFloat(this.purchaserequisitionsitem.value_unit_estimate ? this.purchaserequisitionsitem.value_unit_estimate : 0) - (this.purchaserequisitionsitem.entry_value_discount ? this.purchaserequisitionsitem.entry_value_discount : 0))).toFixed(2)
            },
            goback(){
                 this.$router.go(-1, {query: 'q=s', hash: 'hashFrag'})
            }, 
            formatValue(value) {    
                return parseFloat(value ? value : 0).toFixed(2)
            },
            formatDate(date) {
                return moment.parseZone(date).format('YYYY-MM-DD')
            },
            formatDateTime(date) {
                return moment.parseZone(date).format('YYYY-MM-DD LT')
            },

            async loadPurchaseRequisitionsItems(){
                const id = this.purchaserequisition.id
                const url = `${baseApiUrl}/purchaserequisitionsitems/${id}`
                await axios.get(url).then(res => {
                    this.purchaserequisitionsitems = res.data
                })
           },  
     
            async savepurchaserequisition() {
                if(this.purchaserequisition.id){
                    this.purchaserequisition.user_update_id = this.user.id   
                    this.purchaserequisition.update_date = this.formatDate(Date())
                }else{

                    this.purchaserequisition.user_id = this.user.id   
                    if(!this.compan)
                    {
                         this.$toasted.global.defaultWarning({msg:'Logar na Empresa'}).catch(showError)
                    }else
                    {
                        this.purchaserequisition.company_id = this.compan.id
                    }
                    
                }    
                    const method = this.purchaserequisition.id ? 'put' : 'post'
                    const id = this.purchaserequisition.id ? `/${this.purchaserequisition.id}` : ''
                    await axios[method](`${baseApiUrl}/purchaserequisitions${id}`, this.purchaserequisition)
                        .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.getLastpurchaserequisition()
                        })
                        .catch(showError)
            },
            async savePurchaseRequisitionItem() {
                const method = this.purchaserequisitionsitem.id ? "put" : "post";
                const id = this.purchaserequisitionsitem.id ? `/${this.purchaserequisitionsitem.id}` : "";

                this.purchaserequisitionsitem.user_id = this.user.id   
                this.purchaserequisitionsitem.purchase_requisition_id = this.purchaserequisition.id;

                await axios[method](`${baseApiUrl}/purchaserequisitionsitems${id}`, this.purchaserequisitionsitem)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess();
                        this.purchaserequisitionsitem = {}
                        await this.loadPurchaseRequisitionsItems();
                    })
                    .catch(showError)
            },
            async getLastpurchaserequisition(){
                 const url = `${baseApiUrl}/purchaserequisitionidlast/${this.purchaserequisition.company_id}/?user_id=${this.purchaserequisition.user_id}&requisition_employee_id=${this.purchaserequisition.requisition_employee_id}`
                   await axios(url).then(res=> 
                        this.purchaserequisition = {...this.purchaserequisition,id:res.data.id}
                    )
            },
            async confirmpurchaserequisition() {
                if(this.purchaserequisition.id){

                        if(this.purchaserequisition.requisition_status_id === 2){
                            this.purchaserequisition.requisition_status_id = 1
                            this.docRead = false
                        }
                        else{
                            this.purchaserequisition.requisition_status_id = 2
                            this.docRead = true
                        }
                        this.purchaserequisition.user_update_id = this.user.id   
                        this.purchaserequisition.update_date = this.formatDate(Date())
                        
                                   
                    const method = this.purchaserequisition.id ? 'put' : 'post'
                    const id = this.purchaserequisition.id ? `/${this.purchaserequisition.id}` : ''
                    await axios[method](`${baseApiUrl}/purchaserequisitions${id}`, this.purchaserequisition)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
                }      
            },
            async saveItem() {
                const method = this.purchaserequisitionsitem.id ? "put" : "post";
                const id = this.purchaserequisitionsitem.id ? `/${this.purchaserequisitionsitem.id}` : "";
                this.purchaserequisitionsitem.purchaserequisition_id = this.purchaserequisition.id;
                await axios[method](`${baseApiUrl}/purchaserequisitionsitems${id}`, this.purchaserequisitionsitem)
                    .then(async () => {
                    this.$toasted.global.defaultSuccess();
                    this.purchaserequisitionsitem = {}
                    this.item_stock = {}
                        await this.loadPurchaseRequisitionsItems();
                    })
                    .catch(showError)
            },
            async removeItem(purchaserequisitionsitem) {
                    const id = purchaserequisitionsitem.id
                    await axios.delete(`${baseApiUrl}/purchaserequisitionsitems/${id}`)
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loadPurchaseRequisitionsItems()
                        })
                        .catch(showError)
            },
            async setEntity(entity) {
                if(!this.purchaserequisition.entity_id)
                {
                    this.purchaserequisition.entity_id = entity.id
                }
                const url = `${baseApiUrl}/entitys/${this.purchaserequisition.entity_id}`
                await axios(url).then(res=> this.entity = res.data)
            },
            async setSearchEntity() {
               this.purchaserequisition = {...this.purchaserequisition,entity_id: this.entity_id} 
               await this.getAdvancedValue()
            },   
            async loadCostCenter() {
                const url = `${baseApiUrl}/costcenteranalitic/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.costcenters = res.data.map(costcenter => {
                        return { value: costcenter.id, text: costcenter.name_cost_center }
                        })
                    })
            },
            async loadDocumentStaus() {

            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                   this.documentstatus = res.data.map(documentstatu => {
                    return { value: documentstatu.id, text: documentstatu.name_document_status }
                    })
                })
            },
            async loadItems(){
                const url = `${baseApiUrl}/groupitems/${this.group_item_id}/items`
                await axios.get(url).then(res => {
                    this.items = res.data
                })
            },
            async setItemSearch(itemsearch) {
                this.item= {...itemsearch}
                this.purchaserequisitionsitem.item_id = this.item.id
                this.focusModalEntryItemQuantity()
                await this.loadItemsStock()
            },
            async setItem() {
                const url = `${baseApiUrl}/items/${this.purchaserequisitionsitem.item_id}`
                await axios(url).then(res=> this.item = res.data)
            },
            loadpurchaserequisitionsItem(item){
                this.purchaserequisitionsitem = {...item}
                this.item_stock.complements_name =  item.complements_name
                this.item_stock.initials = item.initials
            },
            async loadPurchaseRequisition(){
                const url = `${baseApiUrl}/purchaserequisitions/${this.purchaserequisition.id}`
                await axios.get(url).then(res => {
                            this.purchaserequisition = {...res.data}
                            this.loadPurchaseRequisitionsItems()
                            this.docRead = true
                    })
            },
            loadGroupItems() {
                const url = `${baseApiUrl}/groupitems`
                axios.get(url).then(res => {
                    this.groupitems = res.data.map(groupitem => {
                        return { value: groupitem.id, text: !groupitem.synthetic ? ' => ' + groupitem.name : groupitem.name, disabled: groupitem.synthetic ? true: false }
                    })
                })
            },
            async setEquipment(equipment) {

                if(!this.purchaserequisitionsitem.equipment_id)
                {
                    this.purchaserequisitionsitem.equipment_id = equipment.id
                }

                const url = `${baseApiUrl}/equipments/${this.orderservice.equipment_id}`
                await axios(url).then(res=> this.equipment = res.data)

            },
             async loadEmployees() {

            const url = `${baseApiUrl}/employees`
            await axios.get(url).then(res => {
                   this.employees = res.data.map(employee => {
                    return { value: employee.id, text: employee.name}
                    })
                })
            },
            setSearchEquipment() {
                this.purchaserequisitionsitem = {...this.purchaserequisitionsitem,equipment_id : this.equipment_id}
            },
            hideModal() {
                this.$bvModal.hide('modalEntity')
                this.$bvModal.hide('modalItem')
            },
            openModalEntity(){
            this.$bvModal.show('modalEntity')
            },
            openModalItem(){
                this.$bvModal.show('modalItem')
            },
            focusModalEntity(){
                this.$refs.focusEntity.focus()
            },
            focusModalItem(){
                this.$refs.focusItem.focus()
            },
             focusModalEntryItem(){
                this.$refs.focusEntryItem.focus()
            },
            focusModalEntryItemQuantity(){
                this.$refs.focusEntryItemQuantity.focus()
            },
            focusModalEntryItemValueUnit(){
                this.$refs.focusEntryItemValueUnit.focus()
            },
            setNewItem(){
                this.purchaserequisitionsitem = {}
            },
            
      },
    watch:{
            $route(to){
                this.purchaserequisition = to.query.purchaserequisitionbase

            } 
        },
       async mounted(){

            if(!this.$route.query.purchaserequisitionbase){
                this.purchaserequisition.id = this.$route.params.id
               await this.loadPurchaseRequisition()
               await this.setEntity()
               this.purchaserequisition = {...this.purchaserequisition,requisition_date : this.formatDate(this.purchaserequisition.requisition_date)}

            }else{
                this.purchaserequisition = this.$route.query.purchaserequisitionbase
                this.docRead = this.purchaserequisition.requisition_status_id === 1 ? false : true
                this.entity.name_entity = this.purchaserequisition.name_entity
                this.entity.cnpj_cpf = this.purchaserequisition.cnpj_cpf
            }

            
            if(!this.purchaserequisition.requisition_date){

               const date = new Date() 
                this.purchaserequisition.requisition_date = moment.utc(date).local().format('YYYY-MM-DD')
            }
            this.loadCostCenter()
            this.loadPurchaseRequisitionsItems()
            this.loadDocumentStaus()
            this.loadGroupItems()
            this.loadEmployees()

        }
}
</script>

<style>
     .record-purchaserequisition select,label{
        font-size: 0.7rem;
    }
    .record-purchaserequisition input{
        font-size: 0.7rem;
    }
     .record-purchaserequisition button{
        font-size: 0.7rem;
    }
     .record-purchaserequisition h6{
        font-size: 0.7rem;

    }

    #modalpurchaserequisitionItem select,label{
        font-size: 0.7rem;
    }

    #modalpurchaserequisitionItem input{
        font-size: 0.7rem;
    }

    #modalpurchaserequisitionItem button{
        font-size: 0.7rem;
    }

   
    #modalItem input {
        font-size: 0.7rem;
    }

    #modalItem button {
        font-size: 0.7rem;
    }
    
  
    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }
</style>
